module.exports = __webpack_public_path__ + "img/f-zero.4c65a9e0.png";